import { ScenarioToRuleWithId } from './types'
import { EMPTY_RULE } from './emptyRyle'

export const scenarioToRuleWithId: ScenarioToRuleWithId = (rules) =>
  !rules.length
    ? [EMPTY_RULE]
    : rules.map((rule, index) => {
        return {
          id: index,
          ...rule
        }
      })
